'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('@atlaskit/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement(_button2.default, {
    appearance: 'subtle',
    onClick: props.onClick,
    spacing: 'none',
    tabIndex: -1,
    iconBefore: props.children
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/calendar/dist/cjs/components/Btn.js
// module id = 1258
// module chunks = 0